import { useEffect, useState } from "react";

const KEY = "fender_dashboard_prefs_v2";

const defaultPrefs = {
  range: "today", // today | week | month | custom
  from_date: null,
  to_date: null,
  branch_id: null,
  assignee_id: null,
  status_filter: null, // optional job-card status filter
  kpi_order: [
    "vehicles_in_workshop",
    "jobs_in_progress",
    "ready_for_delivery",
    "payments_pending",
  ],
  kpi_hidden: [], // subset of KPI keys the user has hidden
};

// The KPIs that are considered mandatory (per spec) and cannot be hidden.
export const MANDATORY_KPIS = [
  "vehicles_in_workshop",
];

export function loadPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...defaultPrefs };
    const parsed = JSON.parse(raw);
    const merged = { ...defaultPrefs, ...parsed };
    // Purge any stale KPI keys removed from the catalog
    const KNOWN = new Set(defaultPrefs.kpi_order);
    merged.kpi_order = (merged.kpi_order || []).filter((k) => KNOWN.has(k));
    // Ensure all default KPIs are present (append any missing at end)
    for (const k of defaultPrefs.kpi_order) {
      if (!merged.kpi_order.includes(k)) merged.kpi_order.push(k);
    }
    merged.kpi_hidden = (merged.kpi_hidden || []).filter((k) => KNOWN.has(k));
    return merged;
  } catch {
    return { ...defaultPrefs };
  }
}

export function savePrefs(prefs) {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch (_) { /* localStorage full or unavailable */ }
}

/**
 * useDashboardPrefs — persists dashboard preferences to localStorage.
 */
export function useDashboardPrefs() {
  const [prefs, setPrefs] = useState(loadPrefs);
  useEffect(() => {
    savePrefs(prefs);
  }, [prefs]);
  const patch = (partial) => setPrefs((p) => ({ ...p, ...partial }));
  return [prefs, patch, setPrefs];
}
